import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUpLeftCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.343 13.657A8 8 0 1 0 13.657 2.343A8 8 0 0 0 2.343 13.657M5.25 12.32l7.071-7.071H5.25z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUpLeftCircle
